import { apiClient, assertValidParam } from '@v2/lib';
import type { CreateDomainPayload } from '@v2/types';

/**
 * Domains Service
 *
 * Domain: Trusted domain management for partners
 * Base path: /admin/domains
 *
 * Mutations:
 *   - createDomain(payload) → POST /admin/domains
 *   - deleteDomain(id)      → DELETE /admin/domains/:id
 */

export const domainsService = {
  createDomain: async (payload: CreateDomainPayload): Promise<string> => {
    const response = await apiClient().post<string>('admin/domains', payload);
    return response.data;
  },

  deleteDomain: async (domainId: string): Promise<void> => {
    const safeId = assertValidParam(domainId, 'domainId');
    await apiClient().delete(`admin/domains/${safeId}`);
  },
};
